import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-865466b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "text-right absolute top-4 right-4"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "bottom-0 absolute p-2 sm:max-w-half"
}
const _hoisted_11 = ["href", "innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "bg-white border-project border-4 rounded-sm flex flex-col relative max-w-4xl p-4 pt-12" }
const _hoisted_14 = { class: "flex flex-row" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 0,
  class: "justify-end items-end p-8 pt-0"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "text-right px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
    }, [
      _createVNode(_component_ScreenWrapper, {
        "class-name": "pt-0",
        next: _ctx.next,
        screen: _ctx.screen,
        "hide-arrow": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", {
              class: _normalizeClass(["sm:col-span-5 main-content text-3xl", _ctx.config.classes.mainContent])
            }, [
              (_ctx.correct)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    innerHTML: _ctx.$rt(_ctx.config.ansOkText)
                  }, null, 8, _hoisted_3))
                : (_ctx.config.ansWrongText)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      innerHTML: _ctx.$rt(_ctx.config.ansWrongText)
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 2,
                      innerHTML: _ctx.$rt(_ctx.tooHighAnswer ? _ctx.config.textAnsTooHigh : _ctx.config.textAnsTooLow)
                    }, null, 8, _hoisted_5)),
              (_ctx.config.textPart1)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 3,
                    class: "mt-8",
                    innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              (_ctx.config.textPart2)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 4,
                    class: "mt-4",
                    innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              _createVNode(_component_BackNextButtons, {
                "color-class": "mt-24",
                "go-to": _ctx.goTo,
                "next-screen": _ctx.config.screenNext
              }, null, 8, ["go-to", "next-screen"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["sm:col-span-3 h-full min-h-50vh flex flex-col items-center justify-center relative", _ctx.config.classes.rightSide])
            }, [
              (_ctx.config.readMore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_ActionButton, {
                      class: _normalizeClass(_ctx.config.classes?.readMoreClasses),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true)),
                      posticon: "<i class='fas fa-chevron-circle-right'></i>",
                      rawtext: _ctx.$t('buttons.iwanttoknowmore')
                    }, null, 8, ["class", "rawtext"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bgImage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "bg-project w-full aspect-square flex flex-col items-center justify-center",
                    style: _normalizeStyle(_ctx.config.bgStyles)
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.bgImage,
                      class: _normalizeClass(["w-full", _ctx.config.classes?.bgImageClasses]),
                      alt: "Logo"
                    }, null, 10, _hoisted_9)
                  ], 4))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          (_ctx.config.source)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_ctx.config.source.link)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.$t(_ctx.config.source.link),
                      class: "text-xs text-gray-900 hover:text-gray-400",
                      target: "_blank",
                      innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                    }, null, 8, _hoisted_11))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: "text-xs",
                      innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                    }, null, 8, _hoisted_12))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["next", "screen"])
    ], 2),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showModal) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showModal = false; _ctx.next()}),
            class: "absolute top-2 right-4 text-project font-bold text-3xl text-right"
          }, " × "),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", {
                class: "",
                innerHTML: _ctx.$rt(_ctx.config.readMore.text1, {name: _ctx.state.nickname.value})
              }, null, 8, _hoisted_16),
              (_ctx.config.readMore.text2)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "mt-8",
                    innerHTML: _ctx.$rt(_ctx.config.readMore.text2, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_17))
                : _createCommentVNode("", true)
            ]),
            (_ctx.config.readMore.image)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("img", {
                    src: _ctx.config.readMore.image,
                    class: "w-xl"
                  }, null, 8, _hoisted_19)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_ActionButton, {
              class: "mt-8 mb-8",
              onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showModal = false; _ctx.next()}),
              rawtext: _ctx.$t('buttons.next')
            }, null, 8, ["rawtext"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}